<template>
  <div class="container pr" v-if="isFinsh">
    <!--    header-->
    <div class="headerView">
      <!-- 坐标城市 -->
      <!-- <div
        class="address pa u-flex u-col-center u-row-between"
        @click="handleClickPosition"
        v-cloak
      >
        <img class="icon-position" src="../../assets/images/icon_loction.png" />
        <span>{{ addressPositionName }}</span>
      </div> -->

      <!-- <van-progress :percentage="progressCount.total" class="progress" /> -->

      <div class="info_top center">
        <div class="flex1">
          <div class="c222 fw500 fs16">恭喜您，通过额度初审!</div>
          <div class="top_des fs11 mt12">
            <span class="c_o">补充资料</span>
            <span class="ml8">最高享提额至20万</span>
          </div>
        </div>
        <img class="img_bg" src="./img/bg_left.png" />
        <div class="ff_d fs30">116,000</div>
        <img class="img_bg" src="./img/bg_left.png" />
      </div>

      <div class="register-form">
        <!-- 姓名 -->
        <van-cell-group
          class="inp-elem-box"
          v-show="formShowControl.isShowName"
        >
          <van-field
            v-model.trim="form.userName"
            maxlength="4"
            input-align="right"
            label="真实姓名"
            class="inp-elem"
            placeholder="请输入您的真实姓名"
            @blur="handleBlur(0)"
            clearable
          />
        </van-cell-group>

        <!-- 年龄 -->
        <van-cell-group class="inp-elem-box" v-show="formShowControl.isShowAge">
          <van-field
            v-model.trim="form.age"
            label="真实年龄"
            type="digit"
            maxlength="2"
            input-align="right"
            class="inp-elem bt"
            placeholder="年龄在22岁-55岁均可申请"
            @blur="handleBlur(1)"
            clearable
          />
        </van-cell-group>

        <!-- 身份证号 -->
        <van-cell-group
          class="inp-elem-box"
          v-show="formShowControl.isShowIdCard"
        >
          <van-field
            v-model.trim="form.idCard"
            label="身份证号"
            type="text"
            input-align="right"
            maxlength="18"
            class="inp-elem bt"
            placeholder="请输入身份证号"
            @blur="handleBlur(2)"
            clearable
          />
        </van-cell-group>
      </div>
    </div>
    <!-- 性别 -->
    <div class="sex" v-show="formShowControl.isShowSex">
      <div class="inp-elem-box inp-elem tags">
        <div class="label-left">性别</div>
        <van-row :gutter="15">
          <van-col
            v-for="(item, index) in formItemData.isShowSex"
            :key="index"
            :class="item.active ? 'active' : ''"
            span="12"
            @click="handleChooseSex(index)"
          >
            <div class="u-flex u-col-center u-row-center">
              {{ item.dictLabel }}
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
    <!-- 借多少(元) -->
    <div class="zhimafen" v-show="formShowControl.isShowLoanMount">
      <div class="inp-elem-box inp-elem tags">
        <div class="label-left">借多少(元)</div>
        <van-row :gutter="15">
          <van-col
            v-for="(item, index) in formItemData.isShowLoanMount"
            :key="index"
            :class="item.active ? 'active' : ''"
            span="12"
            @click="handleChooseLoanMount(index)"
          >
            <div
              :class="`u-flex u-col-center u-row-center ${
                item.tip ? 'item_tip' : ''
              }`"
            >
              {{ item.dictLabel }}
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
    <!-- 借多久(月) -->
    <div
      class="zhimafen"
      v-show="formShowControl.isShowLoanTime && period === undefined"
    >
      <div class="inp-elem-box inp-elem tags">
        <div class="assetView u-flex">
          <div class="label-left">借多久(月)</div>
          <div class="label-tip center">最大程度满足您的需求</div>
        </div>
        <van-row :gutter="15">
          <van-col
            v-for="(item, index) in formItemData.isShowLoanTime"
            :key="index"
            :class="item.active ? 'active' : ''"
            span="12"
            @click="handleChooseLoanTime(index)"
          >
            <div
              :class="`u-flex u-col-center u-row-center ${
                item.tip ? 'item_tip' : ''
              }`"
            >
              {{ item.dictLabel }}
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
    <!-- 用途 -->
    <div class="zhimafen" v-show="formShowControl.isShowLoanPurpose">
      <div class="inp-elem-box inp-elem tags">
        <div class="label-left">借款用途</div>
        <van-row :gutter="10">
          <van-col
            v-for="(item, index) in formItemData.isShowLoanPurpose"
            :key="index"
            :class="item.active ? 'active' : ''"
            span="8"
            @click="handleChooseLoanPurpose(index)"
          >
            <div
              :class="`u-flex u-col-center u-row-center ${
                item.tip ? 'item_tip' : ''
              }`"
            >
              {{ item.dictLabel }}
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
    <!-- 资产信息(多选) -->
    <div class="zhimafen" v-show="formShowControl.isShowAssetsFields">
      <div class="inp-elem-box inp-elem tags">
        <div class="assetView u-flex">
          <div class="label-left">资产信息(多选)</div>
          <div class="label-tip center">资产越多 额度越高</div>
        </div>
        <van-row :gutter="10">
          <van-col
            v-for="(item, index) in formItemData.isShowAssetsFields"
            :key="index"
            :class="item.active ? 'active' : ''"
            span="8"
            @click="handleChooseAssetsInfo(index)"
          >
            <div
              :class="`u-flex u-col-center u-row-center ${
                item.tip ? 'item_tip' : ''
              }`"
            >
              {{ item.dictLabel }}
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
    <!-- 芝麻分(单选) -->
    <div class="zhimafen" v-show="formShowControl.isShowAuthFields">
      <div class="inp-elem-box inp-elem tags">
        <div class="assetView u-flex">
          <div class="label-left">芝麻分(单选)</div>
          <div class="label-tip center">提额幅度大</div>
        </div>
        <van-row :gutter="10">
          <van-col
            v-for="(item, index) in formItemData.isShowAuthFields"
            :key="index"
            :class="item.active ? 'active' : ''"
            span="8"
            @click="handleChooseCredit(index)"
          >
            <div
              :class="`u-flex u-col-center u-row-center ${
                item.tip ? 'item_tip' : ''
              }`"
            >
              {{ item.dictLabel }}
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
    <!-- 京东白条(单选) -->
    <div class="zhimafen" v-show="formShowControl.isShowJdIousFields">
      <div class="inp-elem-box inp-elem tags">
        <div class="assetView u-flex">
          <div class="label-left">京东白条(单选)</div>
          <div class="label-tip center">最大程度满足您的需求</div>
        </div>
        <van-row :gutter="15">
          <van-col
            v-for="(item, index) in formItemData.isShowJdIousFields"
            :key="index"
            :class="item.active ? 'active' : ''"
            span="12"
            @click="handleChooseJddept(index)"
          >
            <div
              :class="`u-flex u-col-center u-row-center ${
                item.tip ? 'item_tip' : ''
              }`"
            >
              {{ item.dictLabel }}
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
    <!-- 教育程度(单选) -->
    <div class="zhimafen" v-show="formShowControl.isShowEducation">
      <div class="inp-elem-box inp-elem tags">
        <div class="label-left">教育程度(单选)</div>
        <van-row :gutter="10">
          <van-col
            v-for="(item, index) in formItemData.isShowEducation"
            :key="index"
            :class="item.active ? 'active' : ''"
            span="8"
            @click="handleChooseEducation(index)"
          >
            <div
              :class="`u-flex u-col-center u-row-center ${
                item.tip ? 'item_tip' : ''
              }`"
            >
              {{ item.dictLabel }}
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
    <!-- 婚姻状况(单选) -->
    <div class="zhimafen" v-show="formShowControl.isShowMarry">
      <div class="inp-elem-box inp-elem tags">
        <div class="assetView u-flex">
          <div class="label-left">婚姻状况(单选)</div>
          <div class="label-tip center">最大程度满足您的需求</div>
        </div>
        <van-row :gutter="15">
          <van-col
            v-for="(item, index) in formItemData.isShowMarry"
            :key="index"
            :class="item.active ? 'active' : ''"
            span="12"
            @click="handleChooseMarry(index)"
          >
            <div
              :class="`u-flex u-col-center u-row-center ${
                item.tip ? 'item_tip' : ''
              }`"
            >
              {{ item.dictLabel }}
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
    <!-- 职业身份(单选) -->
    <div class="zhimafen" v-show="formShowControl.isShowProfession">
      <div class="inp-elem-box inp-elem tags">
        <div class="assetView u-flex">
          <div class="label-left">职业身份(单选)</div>
          <div class="label-tip center">最大程度满足您的需求</div>
        </div>
        <van-row :gutter="10">
          <van-col
            v-for="(item, index) in formItemData.isShowProfession"
            :key="index"
            :class="item.active ? 'active' : ''"
            span="8"
            @click="handleChooseProfession(index)"
          >
            <div
              :class="`u-flex u-col-center u-row-center ${
                item.tip ? 'item_tip' : ''
              }`"
            >
              {{ item.dictLabel }}
            </div>
          </van-col>
        </van-row>
      </div>
    </div>

    <div
      class="address_btn u-flex u-col-center u-row-between mt10"
      @click="handleClickPosition"
      v-cloak
    >
      <span>贷款申请城市</span>
      <span class="address_bg">{{ addressPositionName }}</span>
    </div>

    <!-- 提交 -->
    <div class="footer_btn">
      <button class="btn-submit" v-prevent-reclick @click="handleSubmit">
        获取额度
      </button>
    </div>
    <!-- <div class="bottom_view">
      <img
        class="bottom_icon"
        src="../../assets/images/model8/bottom_icon.png"
      />

      <span class="text-group_1">
        信息仅用于核验,合作机构评估,您的信息将被加密保护
      </span>
    </div> -->

    <!-- 提示浏览器打开遮罩层 -->
    <SharePop :show="showPop" @change="handlePopChange" />

    <!-- 工作城市下拉选 -->
    <van-popup
      v-model="showPickerCity"
      position="bottom"
      safe-area-inset-bottom
      round
    >
      <van-picker
        show-toolbar
        title="请选择工作城市"
        :columns="areaList"
        @change="onCityChange"
        @confirm="onAreaConfirm"
        @cancel="showPickerCity = false"
        value-key="localName"
      />
    </van-popup>
    <!-- 弹窗 -->
    <div class="pop-overlay" v-show="showPopProduct">
      <div class="pop-bg">
        <div class="pop-product">
          <img class="pop-logo" :src="productLogo" alt="" />
          <div class="pop-title flex-row items-center">
            {{ this.product.productName }}
          </div>
        </div>
        <div class="pop-subtitle flex-row items-center">{{ this.feature }}</div>
        <div class="checkView justify-between">
          <van-checkbox v-model="rpChecked" shape="square" icon-size="17px">
          </van-checkbox>
          <div class="text-wrapper_10">
            <span class="text_20">我已阅读并同意</span>
            <span class="text_21" @click.stop="handleProtocol(9)"
              >《用户个人信息共享授权协议》</span
            >
          </div>
        </div>
        <div class="pop-btn">
          <div class="pop-cancel" @click="clickCancel"></div>
          <div class="pop-confirm" @click="clickConfirm"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="././public/js/base.js"></script>
<script>
import SharePop from "@/components/SharePop";
import myBMap from "../../utils/myBMap";
import * as API_Common from "@/api/common.js";
import Cookies from "js-cookie";
import { replace, filtion } from "verification-sensitive";

import { Dialog } from "vant";
import { toRedirectUrlAndSaveRecordNoDebounce } from "@/api/common.js";
import "@/assets/styles/base_new.scss";

window.onpageshow = function (event) {
  if (
    localStorage.getItem("isSubimit") &&
    !localStorage.getItem("isClickAuth")
  ) {
    if (event.persisted) {
      window.location.reload();
    }
  }
};
// 返回弹窗
history.pushState(null, null, window.location.href);
setTimeout(() => {
  window.addEventListener("popstate", (e) => processRetain(e));
}, 500);

const processRetain = () => {
  // 这个函数内控制弹窗的显示，处理相关业务逻辑
  if (this.productList.length > 0) {
    this.showPopProduct = true;
  }
};

export default {
  name: "RegisterEntryModelksNwd",
  components: {
    SharePop,
  },
  data() {
    return {
      isFinsh: false,
      positionStatus: false,
      showPopProduct: false,
      rpChecked: false,
      logo: "",
      feature: "", //弹窗特点
      productLogo: "",
      address: {
        province: "",
        city: "",
      },
      areaList: [{ values: [] }, { values: [] }],
      showPickerCity: false,
      redirect: this.$route.query.redirect,
      created: this.$route.query.created,
      code: this.$route.query.code,
      tid: this.$route.query.tid,
      source: this.$route.query.source,
      isShowView: false,
      period: this.$route.query.period, //借款期限

      progress: 0,
      form: {
        channelNo: this.$route.query.source,
        userName: "",
        idCard: "",
        age: "",
        sex: "", //1：男，2：女
        jddept: "", //白条
        assets: [], //资产信息
        loanAmount: "", //借多少
        loanPeriod: "", //借多久
        loanPurpose: "", //借款用途
        credit: "", //芝麻分
        marriage: "", //婚姻
        education: "", //学历
        gpsCityName: "",
        cityId: "",
        provinceId: "",
        profession: "",
      },
      amount: {},
      gpsRecord: {
        userId: 0,
        channelCode: "",
        provinceName: "",
        cityName: "",
        longitude: "",
        latitude: "",
        gpsDetail: "",
        status: 0,
      },
      //进度条每项占比
      progressCount: {
        total: 0,
        average: 0, //平均每项
        name: 0,
        age: 0,
        idCard: 0,
        jddept: 0,
        loanAmount: 0,
        loanPeriod: 0,
        loanPurpose: 0,
        credit: 0,
        profession: 0,
        marriage: 0,
        education: 0,
        assets: 0,
        sex: 0,
      },

      product: {
        //产品名字
        productName: "",
        //产品icon
        logo: "",
        //产品icon占位图
        productPlaceHolder:
          "https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/8d4f87aba9e348a0b8a48a06a914d47e_mergeImage.png",
        //产品最高额度
        loanAmount: "",
        //产品利率
        loanRate: "",
        isToRegister: undefined,
        hitRecordId: undefined,
      },
      productList: [],
      stepLineMove: false,
      showPop: false,
      formShowControl: {
        isShowName: false,
        isShowIdCard: false,
        isShowLoanMount: false,
        isShowLoanTime: false,
        isShowLoanPurpose: false,
        isShowAuthFields: false,
        isShowJdIousFields: false,
        isShowEducation: false,
        isShowAssetsFields: false,
        isShowMarry: false,
        isShowSex: false,
      },
      formItemData: {
        isShowLoanMount: [
          { dictValue: 1, dictLabel: "1-5万" },
          { dictValue: 2, dictLabel: "5-10万" },
          { dictValue: 3, dictLabel: "10-20万" },
          { dictValue: 4, dictLabel: "20万以上" },
        ],
        //借多久(月)
        isShowLoanTime: [
          { dictValue: 1, dictLabel: "3" },
          { dictValue: 2, dictLabel: "6" },
          { dictValue: 3, dictLabel: "9" },
          { dictValue: 4, dictLabel: "12" },
        ],
        //借款用途
        isShowLoanPurpose: [
          { dictValue: 1, dictLabel: "日常消费" },
          { dictValue: 2, dictLabel: "装修贷款" },
          { dictValue: 3, dictLabel: "医疗贷款" },
          { dictValue: 4, dictLabel: "旅游贷款" },
          { dictValue: 5, dictLabel: "买车贷款" },
        ],
        isShowSex: [
          { dictValue: 1, dictLabel: "男" },
          { dictValue: 2, dictLabel: "女" },
        ],
        //资产信息(多选)
        isShowAssetsFields: [
          { dictValue: 1, dictLabel: "房产", tip: true },
          { dictValue: 2, dictLabel: "车产", tip: true },
          { dictValue: 3, dictLabel: "公积金", tip: true },
          { dictValue: 4, dictLabel: "社保" },
          { dictValue: 5, dictLabel: "商业保险" },
          { dictValue: 6, dictLabel: "企业主", tip: true },
        ],
        //芝麻分(单选)
        isShowAuthFields: [
          { dictValue: 1, dictLabel: "600以下" },
          { dictValue: 2, dictLabel: "600-650" },
          { dictValue: 3, dictLabel: "650-700", tip: true },
          { dictValue: 4, dictLabel: "700以上", tip: true },
          { dictValue: 5, dictLabel: "无" },
        ],
        //京东白条(单选)
        isShowJdIousFields: [
          { dictValue: 1, dictLabel: "5000以下" },
          { dictValue: 2, dictLabel: "5000以上", tip: true },
          { dictValue: 0, dictLabel: "无" },
        ],
        //教育程度(单选)
        isShowEducation: [
          { dictValue: 1, dictLabel: "硕士及以上", tip: true },
          { dictValue: 2, dictLabel: "本科" },
          { dictValue: 3, dictLabel: "大专" },
          { dictValue: 4, dictLabel: "高中" },
          { dictValue: 5, dictLabel: "中专" },
          { dictValue: 6, dictLabel: "初中及以下" },
        ],

        //婚姻状况(单选)
        isShowMarry: [
          { dictValue: 1, dictLabel: "未婚" },
          { dictValue: 2, dictLabel: "已婚" },
          { dictValue: 3, dictLabel: "离异" },
        ],
        //职业身份(单选)
        isShowProfession: [
          { dictLabel: "上班族", dictValue: "上班族" },
          { dictLabel: "企业主", dictValue: "企业主" },
          { dictLabel: "自由职业", dictValue: "自由职业" },
          { dictLabel: "公务员/事业/国企", dictValue: "公务员/事业/国企" },
          // { dictValue: 1, dictLabel: "上班族" },
          // { dictValue: 2, dictLabel: "个体工商户", tip: true },
          // { dictValue: 3, dictLabel: "自由职业者" },
          // { dictValue: 4, dictLabel: "无业" },
          // { dictValue: 5, dictLabel: "在校学生" },
          // { dictValue: 6, dictLabel: "农民" },
          // { dictValue: 7, dictLabel: "私营业主", tip: true },
        ],
      },
      regTest: {
        regUserName: /^[\u4e00-\u9fa5]{2,6}$/,
        regIdcard:
          /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
      },
      h5LoanRemindDesc: "",
      showContent: "",
      showProtocol: false,
      companys: "",
      loaclTitle: "",
      isClickSubmit: false, //点击提交按钮不弹出alertview
      showBackBtn: false, //无产品不显示返回按钮
      // timerUpdate: undefined,
      // timerUpdate5: undefined,
      // timerUpdate10: undefined,
      // timerUpdate30: undefined,
      // timerUpdate60: undefined,
      unionToken: this.$route.query.token,
    };
  },

  mounted() {
    const script = document.createElement("script");
    script.src =
      "https://s1.hdslb.com/bfs/cm/cm-sdk/static/js/track-collect.js";
    script.onload = () => {
      console.log("脚本加载完成");
      // 这里可以调用脚本提供的全局方法
    };
    document.body.appendChild(script);

    let isWeixin = this.isWeixin();
    if (isWeixin) {
      this.showPop = true;
    }
    setTimeout(() => {
      this.stepLineMove = true;
    }, 10);
    localStorage.removeItem("isPopupProduct");
    localStorage.removeItem("isPushAuth");
    this.queryFormItem();
    this.getLogo();
    this.getRiskWarningText();
    this.getProtocol();
    this.requestPopupProduct();
    if (
      localStorage.getItem("isSubimit") &&
      !localStorage.getItem("isClickAuth")
    ) {
      this.submitFormNextGoPage();
    }
    this.channelIncomingControl();
    this.handleUserResidenceTime();
    // 按需使用：A→B→C就需要页面一进来的时候，就添加一个历史记录
    window.history.pushState(null, null, document.URL);
    // 给window添加一个popstate事件，拦截返回键，执行this.onBrowserBack事件，addEventListener需要指向一个方法
    window.addEventListener("popstate", this.onBrowserBack, false);
    console.log("tid:" + this.tid);
    if (this.unionToken) {
      console.log("unionToken:" + this.unionToken);
      this.getUnionToken(this.unionToken);
    }
  },
  destroyed() {
    // 当页面销毁必须要移除这个事件，vue不刷新页面，不移除会重复执行这个事件
    window.removeEventListener("popstate", this.onBrowserBack, false);
  },
  watch: {
    // 弹框监听，当弹框显示的时候，pushState添加一个历史，供返回键使用
    PopupShow: {
      handler(newVal, oldVal) {
        if (newVal.Terms === true) {
          window.history.pushState(null, null, document.URL);
        }
      },
      deep: true,
    },
  },
  computed: {
    addressPositionName() {
      if (this.positionStatus) {
        return `${this.address.province} ${this.address.city}`;
      } else {
        if (this.form.gpsCityName) {
          return this.form.gpsCityName;
        } else {
          return "定位失败";
        }
      }
    },
  },
  methods: {
    onBrowserBack() {
      // 这里写点击返回键时候的事件
      // 比如判断需求执行back()或者go(-2)或者PopupShow=false隐藏弹框
      if (this.productList.length > 0) {
        this.showPopProduct = true;
      }
    },

    getUnionToken(unionToken) {
      API_Common.getUnionToken(unionToken).then((res) => {
        if (res.code == 200) {
          Cookies.set("token", res.data.token);
          window.localStorage.setItem("userId", res.data.userId);
        } else {
          this.$toast(res.msg);
        }
      });
    },

    checkPosition() {
      if (navigator.geolocation) {
        this.initBMap();
      } else {
        this.$toast("当前浏览器不支持定位，请手动选择定位");
        this.manualPosition();
      }
    },

    initBMap() {
      let that = this;
      myBMap.getLocations(
        (address, latitude, longitude) => {
          that.positionStatus = true;
          that.address.province = address.province;
          that.address.city = address.city;
          that.form.gpsCityName = address.city;
          that.gpsRecord.longitude = longitude;
          that.gpsRecord.latitude = latitude;
          that.gpsRecord.gpsDetail = address.gpsDetail;
          that.gpsRecord.status = 1;
        },
        (error) => {
          that.$toast.fail("定位失败，请手动选择城市");
          that.manualPosition();
        }
      );
    },

    manualPosition() {
      this.positionStatus = false;
    },

    handleClickPosition() {
      if (!this.positionStatus) {
        this.getArea(0, 0);
        this.showPickerCity = true;
      }
    },
    //姓名 年龄校验
    handleBlur(index) {
      switch (index) {
        case 0:
          API_Common.delayModel8SUpdate(this.source, 0, this.tid, 11);
          if (this.form.userName !== "") {
            if (!this.regTest.regUserName.test(this.form.userName)) {
              this.$toast("请输入正确的姓名");
              this.amount.name = 0;
              this.progressCount.name = 0;
            } else {
              this.progressCount.name = this.progressCount.average;
              this.progressCalculate();
            }
          } else {
            this.amount.name = 0;
            this.progressCount.name = 0;
          }
          break;
        case 1:
          API_Common.delayModel8SUpdate(this.source, 0, this.tid, 12);
          if (!this.form.age || this.form.age == "") {
            this.form.age = "";
            this.$toast("请输入年龄");
            this.amount.age = 0;
            this.progressCount.age = 0;
          } else if (
            parseInt(this.form.age) < 22 ||
            parseInt(this.form.age) > 55
          ) {
            this.$toast("您的年龄不符合申请要求");
            this.form.age = "";
            this.amount.age = 0;
            this.progressCount.age = 0;
          } else {
            this.progressCount.age = this.progressCount.average;
            this.progressCalculate();
          }
          break;
        case 2:
          if (this.form.idCard !== "") {
            if (
              !this.regTest.regIdcard.test(this.form.idCard) ||
              !this.validateIDCard(this.form.idCard)
            ) {
              this.$toast("请输入正确的身份证号码");
            } else {
              this.progressCount.idCard = this.progressCount.average;
              this.progressCalculate();
            }
          }
          break;
      }
      this.progressCalculate();
    },
    validateIDCard(idCard) {
      const weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      const checkCodes = [
        "1",
        "0",
        "X",
        "9",
        "8",
        "7",
        "6",
        "5",
        "4",
        "3",
        "2",
      ];
      let sum = 0;
      for (let i = 0; i < 17; i++) {
        sum += parseInt(idCard.charAt(i)) * weights[i];
      }
      const mod = sum % 11;
      const checkCode = checkCodes[mod];
      return idCard.charAt(17).toUpperCase() === checkCode;
    },
    //计算进度&可借金额
    progressCalculate() {
      this.progressCount.total = 0;
      this.progressCount.total =
        this.progressCount.name +
        this.progressCount.age +
        this.progressCount.assets +
        this.progressCount.idCard +
        this.progressCount.loanAmount +
        this.progressCount.loanPeriod +
        this.progressCount.loanPurpose +
        this.progressCount.credit +
        this.progressCount.profession +
        this.progressCount.jddept +
        this.progressCount.marriage +
        this.progressCount.sex +
        this.progressCount.education;
      if (this.progressCount.total > 95 && this.progressCount.total < 100) {
        this.progressCount.total = 100;
      }
      if (this.progressCount.total > 100) {
        this.progressCount.total = 100;
      }
    },
    initProgressCalculate() {
      let optionsCount = 0;
      if (this.formShowControl.isShowName) {
        optionsCount++;
      }
      if (this.formShowControl.isShowIdCard) {
        optionsCount++;
      }
      if (this.formShowControl.isShowAge) {
        optionsCount++;
      }
      if (this.formShowControl.isShowSex) {
        optionsCount++;
      }
      if (this.formShowControl.isShowAssetsFields) {
        optionsCount++;
      }
      if (this.formShowControl.isShowAuthFields) {
        optionsCount++;
      }

      if (this.formShowControl.isShowJdIousFields) {
        optionsCount++;
      }
      if (this.formShowControl.isShowLoanMount) {
        optionsCount++;
      }
      if (this.formShowControl.isShowLoanTime && this.period === undefined) {
        optionsCount++;
      }
      if (this.formShowControl.isShowLoanPurpose) {
        optionsCount++;
      }
      if (this.formShowControl.isShowEducation) {
        optionsCount++;
      }
      if (this.formShowControl.isShowMarry) {
        optionsCount++;
      }
      if (this.formShowControl.isShowProfession) {
        optionsCount++;
      }
      this.progressCount.average = Math.round(100 / optionsCount);
    },
    //查询需要填写的进件资料
    channelIncomingControl() {
      API_Common.channelIncomingControl(this.form.channelNo).then((res) => {
        if (res.code == 200) {
          this.formShowControl = res.data;
          this.initProgressCalculate();
          this.checkPosition();
        }
      });
    },
    handleSubmit() {
      API_Common.delayModel8SUpdate(this.source, 0, this.tid, 17);
      if (this.period) {
        this.form.loanPeriod = this.period;
      }
      if (!this.positionStatus && !this.form.cityId) {
        this.$toast("请选择您所在的城市");
        return;
      } else if (this.form.userName === "" && this.formShowControl.isShowName) {
        this.$toast("请输入姓名");
        return;
      } else if (
        !this.regTest.regUserName.test(this.form.userName) &&
        this.formShowControl.isShowName
      ) {
        this.$toast("请输入合法的姓名");
        return;
      }
      if (this.form.age === "" && this.formShowControl.isShowAge) {
        this.$toast("请输入年龄");
        return;
      }
      if (this.form.idCard === "" && this.formShowControl.isShowIdCard) {
        this.$toast("请输入身份证号");
        return;
      } else if (
        !this.regTest.regIdcard.test(this.form.idCard) &&
        this.formShowControl.isShowIdCard
      ) {
        this.$toast("请输入合法的身份证号");
        return;
      }

      if (this.form.sex === "" && this.formShowControl.isShowSex) {
        this.$toast("请选择性别");
        return;
      }

      if (this.form.loanAmount === "" && this.formShowControl.isShowLoanMount) {
        this.$toast("请选择借多少");
        return;
      }
      if (this.form.loanPeriod === "" && this.formShowControl.isShowLoanTime) {
        this.$toast("请选择借多久");
        return;
      }
      if (
        this.form.loanPurpose === "" &&
        this.formShowControl.isShowLoanPurpose
      ) {
        this.$toast("请选择借款用途");
        return;
      }
      this.formItemData.isShowAssetsFields.map((i) => {
        if (i.active) {
          this.form.assets.push(i.dictValue);
        }
      });
      if (
        this.form.assets.length === 0 &&
        this.formShowControl.isShowAssetsFields
      ) {
        this.$toast("请至少选择一项资产");
        return;
      }
      if (this.form.credit === "" && this.formShowControl.isShowAuthFields) {
        this.$toast("请选择芝麻分");
        return;
      }
      if (!this.form.jddept && this.formShowControl.isShowJdIousFields) {
        this.$toast("请选择京东白条");
        return;
      }

      if (this.form.education === "" && this.formShowControl.isShowEducation) {
        this.$toast("请选择教育程度");
        return;
      }
      if (this.form.marriage === "" && this.formShowControl.isShowMarry) {
        this.$toast("请选择婚姻状况");
        return;
      }
      if (
        this.form.profession === "" &&
        this.formShowControl.isShowProfession
      ) {
        this.$toast("请选择婚姻状况");
        return;
      }
      // let flag = filtion(this.form.userName);
      // if (flag) {
      //   this.$toast("请输入合法的姓名");
      //   return;
      // }
      this.addGpsRecord();
      let datas = {
        ...this.form,
        ...{
          userName: this.form.userName,
        },
      };
      let fun = "submitAnEntry";
      API_Common[fun](datas).then((res) => {
        if (res.code === 200 || res.msg == "insertExisit") {
          API_Common.delayModel8SUpdate(this.source, 0, this.tid, 4);
          this.submitFormNextGoPage();
        } else {
          this.$toast(res.msg);
        }
      });
    },
    queryFormItem() {
      API_Common.queryFormItem().then((res) => {
        if (res.code == 200) {
          this.formItemData.credit = res.data.credit;
          this.computedActive(this.formItemData);
          this.isFinsh = true;
        } else {
          this.$toast(res.msg);
        }
      });
    },
    //上传gps定位
    addGpsRecord() {
      let userId = window.localStorage.getItem("userId");
      this.gpsRecord.userId = userId ? userId : 0;
      this.gpsRecord.channelCode = this.source;
      this.gpsRecord.provinceName = this.address.province;
      this.gpsRecord.cityName = this.address.city;
      this.gpsRecord.gpsDetail = this.gpsRecord.gpsDetail || "定位失败";
      API_Common.addGpsRecord(this.gpsRecord).then((res) => {});
    },

    getLogo() {
      API_Common.getRegister2Logo(this.form.channelNo).then((res) => {
        if (res.code == 200) {
          this.logo = res.data;
        } else {
          this.$toast(res.msg);
        }
      });
    },

    getRiskWarningText() {
      API_Common.queryRiskWarning(this.form.channelNo).then((res) => {
        if (res.code == 200) {
          const { h5LoanRemindDesc } = res.data;
          this.h5LoanRemindDesc = h5LoanRemindDesc.replace(/[;；]/g, "\n");
        }
      });
    },

    computedActive(objs) {
      const assetsFieldsIndex = Math.floor(
        Math.random() * this.formItemData.isShowAssetsFields.length
      );
      const authFieldsIndex = Math.floor(
        Math.random() * (this.formItemData.isShowAuthFields.length - 1)
      );
      Object.keys(objs).forEach((key) => {
        let arr = objs[key];
        //资产信息默认值
        if (key === "isShowAssetsFields") {
          arr.map((item, index) => {
            item.active = index === assetsFieldsIndex;
          });
        } else if (key === "isShowAuthFields") {
          //芝麻分默认值
          arr.map((item, index) => {
            item.active = index === authFieldsIndex;
            if (index === authFieldsIndex) {
              this.form.credit =
                this.formItemData.isShowAuthFields[index].dictLabel;
            }
          });
        } else {
          arr.map((item) => {
            item.active = false;
          });
        }
      });
    },

    handleChooseSex(index) {
      API_Common.delayModel8SUpdate(this.source, 0, this.tid, 13);
      this.formItemData.isShowSex.map((item) => {
        item.active = false;
      });
      this.formItemData.isShowSex[index].active = true;
      this.form.sex = this.formItemData.isShowSex[index].dictValue;
      this.$forceUpdate();
      this.progressCount.sex = this.progressCount.average;
      this.progressCalculate();
    },
    //借多少钱
    handleChooseLoanMount(index) {
      API_Common.delayModel8SUpdate(this.source, 0, this.tid, 14);
      this.formItemData.isShowLoanMount.map((item) => {
        item.active = false;
      });
      this.formItemData.isShowLoanMount[index].active = true;
      this.form.loanAmount = this.formItemData.isShowLoanMount[index].dictLabel;
      this.$forceUpdate();
      this.progressCount.loanAmount = this.progressCount.average;
      this.progressCalculate();
    },
    //借多久
    handleChooseLoanTime(index) {
      this.formItemData.isShowLoanTime.map((item) => {
        item.active = false;
      });
      this.formItemData.isShowLoanTime[index].active = true;
      this.form.loanPeriod = this.formItemData.isShowLoanTime[index].dictLabel;
      this.$forceUpdate();
      this.progressCount.loanPeriod = this.progressCount.average;
      this.progressCalculate();
    },

    //用途
    handleChooseLoanPurpose(index) {
      this.formItemData.isShowLoanPurpose.map((item) => {
        item.active = false;
      });
      this.formItemData.isShowLoanPurpose[index].active = true;
      this.form.loanPurpose =
        this.formItemData.isShowLoanPurpose[index].dictLabel;
      this.$forceUpdate();
      this.progressCount.loanPurpose = this.progressCount.average;
      this.progressCalculate();
    },
    //芝麻分
    handleChooseCredit(index) {
      API_Common.delayModel8SUpdate(this.source, 0, this.tid, 16);
      this.formItemData.isShowAuthFields.map((item) => {
        item.active = false;
      });
      this.formItemData.isShowAuthFields[index].active = true;
      this.form.credit = this.formItemData.isShowAuthFields[index].dictLabel;
      this.$forceUpdate();
      this.progressCount.credit = this.progressCount.average;
      this.progressCalculate();
    },
    //京东白条
    handleChooseJddept(index) {
      this.formItemData.isShowJdIousFields.map((item) => {
        item.active = false;
      });
      this.formItemData.isShowJdIousFields[index].active = true;
      this.form.jddept = this.formItemData.isShowJdIousFields[index].dictValue;
      this.$forceUpdate();
      this.progressCount.jddept = this.progressCount.average;
      this.progressCalculate();
    },

    //教育程度
    handleChooseEducation(index) {
      this.formItemData.isShowEducation.map((item) => {
        item.active = false;
      });
      this.formItemData.isShowEducation[index].active = true;
      this.form.education = this.formItemData.isShowEducation[index].dictLabel;
      this.$forceUpdate();
      this.progressCount.education = this.progressCount.average;

      this.progressCalculate();
    },
    //资产信息
    handleChooseAssetsInfo(index) {
      API_Common.delayModel8SUpdate(this.source, 0, this.tid, 15);
      if (this.formItemData.isShowAssetsFields[index].active) {
        let arr = this.formItemData.isShowAssetsFields.filter(
          (item) => item.active
        );

        if (arr.length > 1) {
          this.formItemData.isShowAssetsFields[index].active = false;
        } else {
          this.$toast.fail("至少保留一项");
        }
      } else {
        this.formItemData.isShowAssetsFields[index].active = true;
      }
      this.progressCount.assets = this.progressCount.average;
      this.progressCalculate();
      this.$forceUpdate();
    },
    //婚姻
    handleChooseMarry(index) {
      this.formItemData.isShowMarry.map((item) => {
        item.active = false;
      });
      this.formItemData.isShowMarry[index].active = true;
      this.form.marriage = this.formItemData.isShowMarry[index].dictLabel;
      this.$forceUpdate();
      this.progressCount.marriage = this.progressCount.average;
      this.progressCalculate();
    },
    //职业
    handleChooseProfession(index) {
      this.formItemData.isShowProfession.map((item) => {
        item.active = false;
      });
      this.formItemData.isShowProfession[index].active = true;
      this.form.profession =
        this.formItemData.isShowProfession[index].dictLabel;
      this.$forceUpdate();
      this.progressCount.profession = this.progressCount.average;
      this.progressCalculate();
    },

    handlePopChange(show) {
      this.showPop = show;
    },

    getArea(parentId, index) {
      API_Common.getRegions(parentId).then((res) => {
        if (200 === res.code) {
          this.areaList[index].values = [{ localName: "请选择" }, ...res.data];
          this.areaList = [...this.areaList]; //更新areaList
          this.loading = false;
        } else {
          this.$toast.fail("获取省份失败");
        }
      });
    },

    onCityChange(picker, values, index) {
      if (values[index].localName === "请选择" && index !== 1) {
        this.areaList[1].values = [{ localName: "请选择" }];
      } else {
        if (!index) {
          this.getArea(values[0].id, index + 1); //传参 参数为上层选择的地区的id
        }
      }
    },

    onAreaConfirm(picker) {
      if (
        picker[0].localName === "请选择" ||
        picker[1].localName === "请选择"
      ) {
        this.$toast.fail("请选择完整的省市");
        return false;
      } else {
        this.form.gpsCityName = `${picker[0].localName} ${picker[1].localName}`;
        this.form.provinceId = picker[0].id;
        this.form.cityId = picker[1].id;
        this.showPickerCity = false;
      }
    },

    getProtocol() {
      Promise.all([
        API_Common.getContent({ pageType: 11 }),
        API_Common.getContent({ pageType: 10 }),
      ]).then((res) => {
        this.xxsq = res[0].data.content;
        this.zqgz = res[1].data.content;
      });
    },

    submitFormNextGoPage() {
      // 统一的路由跳转逻辑
      const navigate = () => {
        this.$router.replace({
          name: "stateWatingModel8_nwd",
          query: {
            source: this.form.channelNo,
            code: this.code,
          },
        });
      };

      // B站归因特殊处理
      if (this.source === "6hoyNtRKq1") {
        try {
          if (
            window.bilicm &&
            window.bilicm.mbase &&
            window.bilicm.mbase.report_data
          ) {
            window.bilicm.mbase.report_data();
          } else {
            console.warn("B站归因SDK未正确加载");
          }
        } catch (e) {
          console.error("B站归因上报失败:", e);
        }
      }

      // 统一使用500ms延迟
      setTimeout(navigate, 500);
    },
    //请求进件弹窗产品
    requestPopupProduct() {
      API_Common.getPopupProductList(this.form.channelNo).then((res) => {
        if (res.code === 200) {
          var list = res.data.list;
          if (list.length > 0) {
            this.productList = list;
            this.product = list[0];
            this.product.loanRate = this.product.loanRate + "%";
            this.productLogo = this.product.logo;
            if (this.product.prodFeature) {
              this.feature = this.product.prodFeature;
            } else {
              this.feature = "专业一站式借款平台";
            }
            this.showBackBtn = true;
          }
        }
      });
    },
    handleProtocol(pageType) {
      window.location.href = "/protocol.html?pageType=" + pageType;
      localStorage.setItem("isClickAuth", "YES");
    },
    backBtnDidAction() {
      if (this.product.productName) {
        this.showPopProduct = true;
      }
    },
    //弹窗继续填写
    clickCancel() {
      this.showPopProduct = false;
    },
    //     点击推荐产品立即申请
    clickConfirm() {
      if (!this.rpChecked) {
        this.$toast("请勾选同意协议及政策");
        return;
      }
      this.handleGoLink(this.product);
    },
    handleGoLink(item) {
      const buriedData = {
        productId: item.productId,
        showPage: 5,
      };
      let redirectUrl = item.linkUrl; // 默认跳转 URL
      if (item.isToRegister == 1) {
        API_Common.getRegister2CompanyUrl(item.productId, item.hitRecordId)
          .then((res) => {
            if (res.code === 200 && res.data) {
              redirectUrl = res.data;
            } else {
              console.warn("getRegister2CompanyUrl 返回数据异常，使用默认 URL");
            }
          })
          .catch((error) => {
            console.error("getRegister2CompanyUrl failed:", error);
          })
          .finally(() => {
            //无论api成功或者失败 都执行跳转和埋点
            toRedirectUrlAndSaveRecordNoDebounce(
              redirectUrl,
              buriedData,
              item.isWeCom
            );
          });
      } else {
        toRedirectUrlAndSaveRecordNoDebounce(
          redirectUrl,
          buriedData,
          item.isWeCom
        );
      }
    },

    //埋点 监听停留时间
    handleUserResidenceTime() {
      API_Common.delayModel8SUpdate(this.source, 0, this.tid, 2);
    },
  },
};
</script>

<style scoped>
@import "../../css/popupProduct.css"; /*引入公共样式*/

iframe {
  display: block;
}
</style>

<style lang="scss" scoped>
body {
  overflow: hidden; /* 禁止页面滚动 */
}

.container {
  height: 100vh;
  overflow: auto;
  background: #f2f4f9;
  padding: 0.3rem 0.35rem 2rem;

  .van-overlay {
    z-index: 3;
  }
}

.headerView {
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #fffaf7 0, #ffe3da 2rem, #fff 2rem);
  border: 0.02rem solid #fff;
  padding-bottom: 0.32rem;
}

.address_btn {
  border-radius: 0.12rem;
  font-size: 0.28rem;
  color: #2a2f45;
  padding: 0.46rem 0.28rem;
  background: #fff;
  .address_bg {
    padding-right: 0.4rem;
    background: #fff url("./img/icon2.png") no-repeat right center/.26rem;
  }
}

.icon-position {
  width: 0.18rem;
  height: 0.22rem;
  margin-right: 0.04rem;
}

.progress {
  margin-top: 0.7rem;
  background-color: #f2f2f2; /* 设置你想要的背景颜色 */
}

.text-wrapper_5 {
  width: 100%;
  overflow-wrap: break-word;
  font-size: 0;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  margin-top: 0.4rem;
}

.text-wrapper_6 {
  width: 100%;
  overflow-wrap: break-word;
  font-size: 0;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  margin-top: 0.1rem;
  margin-bottom: 0.1rem;
}

.bottom_view {
  width: 100%;
  overflow-wrap: break-word;
  font-size: 0;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  margin-left: 10px;
}

.text_7 {
  width: 210px;
  height: 30px;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 18px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 25px;
}

.paragraph_1 {
  overflow-wrap: break-word;
  color: #666666;
  font-size: 12px;
  font-family: PingFangSC-Regular;
  text-align: left;
  white-space: normal;
  margin-top: 0.1rem;
}

.scale {
  top: 0;
  left: 0;
  width: 6.64rem;
  height: 6.64rem;
}

.assetView {
  padding-bottom: 0rem;
  font-size: 0px;
}

.logo {
  width: 1.2rem;
  height: 0.28rem;
  margin-bottom: 0.2rem;
}

.register-form {
  // margin-top: 0.1rem;
  padding-top: 0.2rem;
  border-radius: 0.12rem 0.12rem 0 0;
  overflow: hidden;
  border-bottom: 0.02rem solid #f2f4f9;
}

.inp-elem-box {
  // margin-bottom: 0.1rem;
  border-radius: 0.12rem;
  margin-top: -0.12rem;
}

.inp-elem {
  padding: 0.2rem 0.26rem 0.32rem;
  background-color: #fff;
}

.van-hairline--top-bottom::after {
  display: none;
}

.label-left {
  font-size: 0.28rem;
  font-weight: 700;
  color: #2a2f45;

  > span {
    color: #c3c2c6;
  }

  > small {
    display: block;
    margin: 0.1rem 0;
  }

  .highlight {
    color: #ff7f35;
  }
}

.label-tip {
  padding: 0 0.1rem;
  height: 0.28rem;
  margin-left: 0.12rem;
  color: #e97b2e;
  font-size: 0.18rem;
  background: #fff7f2;
  border-radius: 0.04rem;
  border: 0.02rem solid #f2d4bf;
}

.tags {
  font-size: 16px;
  color: #333333;
}

.van-col {
  > div {
    width: 100%;
    margin-top: 0.2rem;
    min-width: 2rem;
    height: 0.72rem;
    background: #f8f9fa;
    border-radius: 0.16rem;
    border: 0.02rem solid #f8f9fa;
    font-size: 0.28rem;
    color: #666;
  }
}

.tags .active {
  > div {
    border-color: #ef4034;
    background: #fff1eb;
  }
}

.footer_btn {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0.32rem;
  background: #fff;
}

.btn-submit {
  display: block;
  width: 100%;
  height: 0.88rem;
  line-height: 0.88rem;
  background: linear-gradient(90deg, #f87464 0%, #ef4034 100%);
  font-size: 0.32rem;
  font-weight: 500;
  color: #ffffff;
  border-radius: 0.88rem;
}

.btn-submit-tips {
  font-size: 0.24rem;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  color: #8884e9;

  > p {
    margin-left: 0.05rem;
  }
}

.bottom {
  margin: 0.3rem -0.1rem 0;
  font-family: PingFangSC, PingFangSC-Regular;
  font-size: 0.24rem;
  font-weight: 400;
  text-align: center;
  color: #8884e9;
  line-height: 0.4rem;
  display: block;
  white-space: pre-line;
}

.section_1 {
  position: relative;
  width: 8.22rem;
  height: 4.94rem;
}

.label_1 {
  width: 0.44rem;
  height: 0.44rem;
  margin-top: 0.02rem;
}

.text-wrapper_1 {
  background-color: rgba(255, 255, 255, 0.17);
  border-radius: 5px;
  height: 0.76rem;
  border: 1px solid rgba(255, 255, 255, 0.32);
  margin-left: 0.4rem;
  width: 2rem;
}

.text_8 {
  width: 1.68rem;
  height: 0.34rem;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 0.4rem;
  text-align: right;
  white-space: nowrap;
  line-height: 0.34rem;
}

.bottom_icon {
  width: 12px;
  height: 15px;
  background-size: cover;
  filter: hue-rotate(100deg);
}

.text-group_1 {
  width: 276px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 12px;
  text-align: left;
  white-space: nowrap;
  line-height: 15px;
}

::v-deep {
  .van-field__label {
    font-family: PingFangSC, PingFangSC-Medium;
    font-size: 14px;
    color: #2a2f45;
  }

  .van-progress__pivot {
    font-size: 12px;
    background-color: #d93c3a;
  }

  .van-progress__portion {
    background-color: #d93c3a;
  }
}

.info_top {
  padding: 0.4rem 0.28rem 0.36rem;
  .img_bg {
    width: 0.44rem;
    &:last-child {
      transform: rotateY(180deg);
    }
  }
  .ff_d {
    color: #ef4034;
  }
  .top_des {
    padding-left: 0.38rem;
    background: url("./img/icon1.png") no-repeat 0/0.26rem;
  }
}
.bt {
  border-top: 0.02rem solid #f2f4f9;
}
.item_tip {
  position: relative;
  &::after {
    content: "";
    position: absolute;
    top: -0.02rem;
    right: -0.02rem;
    width: 0.68rem;
    height: 0.28rem;
    background: url("./img/tip.png") no-repeat 0/100%;
  }
}
</style>
